export const memberCountSingular = "kdFyBd";
export default {memberCountSingular};